import React from 'react';
import { LockIcon, RefreshCwIcon, MailIcon, CalendarCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const steps = [{
  icon: CalendarCheckIcon,
  title: 'Recibe el protocolo hoy',
  text: 'Acceso instantáneo a los 7 capítulos completos.'
}, {
  icon: RefreshCwIcon,
  title: 'Aplica los 7 días',
  text: 'Sigue el checklist. Sin culpa si un día fallas: simplemente continúa.'
}, {
  icon: LockIcon,
  title: 'Observa los cambios',
  text: 'Espejo, energía, claridad mental y digestión.'
}, {
  icon: MailIcon,
  title: 'Dentro de 60 días, decides',
  text: 'Si no funcionó, un email de una frase basta para recuperar tu dinero.'
}];
export function Guarantee() {
  return <section className="w-full bg-sand/50 py-16 sm:py-24" aria-labelledby="garantia-title" style={{
    paddingTop: "64px"
  }} data-id="element-118" data-mp="1ee3qikbiq8x8">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-119" data-mp="qn7vlebrmxlr">
        <div className="overflow-hidden rounded-3xl border border-sage/30 bg-cream shadow-soft" data-id="element-120" data-mp="lp6c4safgw9r">
          <div className="grid gap-10 p-6 sm:p-10 lg:grid-cols-[0.75fr_1.25fr] lg:items-center lg:gap-14" data-id="element-121" data-mp="ozjbwl3tncpo">
            <Reveal data-id="element-122" data-mp="tymf0008r8v0">
              <div className="relative mx-auto max-w-[260px]" data-id="element-123" data-mp="txt8n0572lde">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/1adfc06c-40c8-4d27-8893-c5b3567cc096.jpg" alt="Sello de garantía de satisfacción" className="w-full rounded-full" loading="lazy" data-id="element-124" data-mp="tw9rz8fmm8b3" />
                <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-125" data-mp="60x9n2wkjfk6">
                  <span className="font-display text-4xl font-semibold text-cream drop-shadow-sm" data-id="element-126" data-mp="ayyvfvldpszc">
                    60
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-cream/90" data-id="element-127" data-mp="f3gc3lwfzq5w">
                    días
                  </span>
                </div>
                <p className="mt-4 text-center text-sm font-semibold uppercase tracking-widest text-sageDeep" data-id="element-128" data-mp="1qfz96vt8tj9x">
                  Garantía de reembolso de 60 días
                </p>
              </div>
            </Reveal>

            <div data-id="element-129" data-mp="3rktavovr496z">
              <Reveal data-id="element-130" data-mp="3nh52j3zap9ko">
                <p className="text-xs font-semibold uppercase tracking-widest text-sageDeep" data-id="element-131" data-mp="3nhoe82ycr1q9">
                  Inversión segura
                </p>
                <h2 id="garantia-title" className="mt-3 font-display text-3xl font-semibold leading-tight text-bark sm:text-4xl" data-id="element-132" data-mp="5aqoz64xv1mt">
                  Riesgo cero. Resultados garantizados.
                </h2>
                <p className="mt-5 text-base leading-relaxed text-ink/85" data-id="element-133" data-mp="38q60kbsytja2">
                  Pruébalo durante 2 meses completos sin compromiso. Estoy tan segura de la
                  efectividad del Interruptor del Cortisol que no te pido que confíes en mis
                  palabras, sino en tus resultados.
                </p>
              </Reveal>

              <ol className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-134" data-mp="2q0pkuh8plk92">
                {steps.map(({
                icon: Icon,
                title,
                text
              }, i) => <Reveal key={title} as="li" delay={Math.min(i * 0.04, 0.16)} data-id="element-135" data-mp="10klubsa6cu5i" data-mpi={i}>
                    <div className="h-full rounded-xl border border-bark/10 bg-sand/40 p-5" data-id="element-136" data-mp="10isougbasfz3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-sageDeep/10 text-sageDeep" data-id="element-137" data-mp="15df3cscoeone">
                        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-138" data-mp="vlitkk189a3c" />
                      </span>
                      <h3 className="mt-4 font-semibold leading-snug text-bark" data-id="element-139" data-mp="1jb3kpq7jbdnp">{title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-ink/75" data-id="element-140" data-mp="1oa7uoj2a9ff3">{text}</p>
                    </div>
                  </Reveal>)}
              </ol>

              <Reveal data-id="element-141" data-mp="1a9x31dt5fwsv">
                <p className="mt-8 border-l-2 border-sageDeep pl-5 font-display text-xl leading-snug text-bark sm:text-2xl" data-id="element-142" data-mp="1acjdbl7fcqes">
                  Te devolveré cada centavo. Sin preguntas, sin formularios, sin condiciones.
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>;
}